export { PhotoCollage } from './PhotoCollage';
